import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ProfilePictureStore} from './profile-picture-store';
import {CurrentUser} from '../user/current-user.service';
import {Observable} from 'rxjs';
import {ProfilePicture} from './profile-picture';
import {tap} from 'rxjs/operators';
import {ProfilePictureQuery} from './profile-picture-query';

const API_URL = environment.API_URL;

@Injectable({
  providedIn: 'root'
})
export class ProfilePictureService {

  constructor(private profilePictureStore: ProfilePictureStore,
              private profilePictureQuery: ProfilePictureQuery,
              private currentUser: CurrentUser,
              private http: HttpClient) {
  }

  deleteProfilePictureForCurrentUser(): Observable<void> {
    return this.deleteProfilePicture(this.currentUser.keycloakId);
  }

  deleteProfilePicture(userId: string): Observable<void> {
    const backup: ProfilePicture = this.profilePictureQuery.getProfilePicture(userId);
    this.profilePictureStore.remove(userId);

    return this.http.delete<void>(
      API_URL + '/users/' + userId + '/profile-image',
      {
        headers: new HttpHeaders({})
      }
    ).pipe(tap(
      () => {
      },
      () => {
        console.error('Unable to delete profile picture. Restoring backup.');
        this.restore(userId, backup);
      }
    ));
  }

  updateProfilePictureForCurrentUser(base64Data: string | undefined | null): Observable<void> {
    return this.updateProfilePicture(this.currentUser.keycloakId, base64Data);
  }

  updateProfilePicture(userId: string, base64Data: string | undefined | null): Observable<void> {
    const backup: ProfilePicture = this.profilePictureQuery.getProfilePicture(userId);

    if (!base64Data) {
      console.error('Unable to update profile picture with a value of: ' + base64Data);
      console.error('Did you mean to delete the picture?');
      return;
    }
    const newState: ProfilePicture = {
      base64: base64Data,
      loaded: true
    };
    this.profilePictureStore.upsert(userId, () => newState);

    return this.uploadMultipart(userId, base64Data, backup);
  }

  private uploadMultipart(userId: string, base64Data: string, backup: ProfilePicture): Observable<void> {
    const blob = this.base64ToBlob(base64Data);
    const formData = new FormData();
    formData.append('image', blob, 'profile.jpg');

    return this.http.put<void>(
      API_URL + '/users/' + userId + '/profile-image',
      formData
    ).pipe(tap(
      () => {
      },
      () => {
        console.error('Unable to update profile picture. Restoring backup.');
        this.restore(userId, backup);
      }
    ));
  }

  private restore(userId: string, backup: ProfilePicture | undefined): void {
    if (!backup) {
      this.profilePictureStore.remove(userId);
      return;
    }
    this.profilePictureStore.upsert(userId, () => backup);
  }

  private base64ToBlob(base64DataUri: string): Blob {
    const parts = base64DataUri.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const bytes = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) {
      bytes[i] = raw.charCodeAt(i);
    }
    return new Blob([bytes], {type: contentType});
  }

}
